import { endPoints } from 'api/endpoints';
import axios from 'api/request';

/**
 * Generates a resource name using the CMP API
 * @param {Object} params - Parameters for resource name generation
 * @param {string} params.appShortName - Application short name
 * @param {string} params.environment - Environment (e.g., "Development", "Production")
 * @param {string} params.resourceType - Type of resource (e.g., "awslbtg" for ALB Target Group)
 * @param {string} params.accountId - AWS Account ID
 * @param {string} params.region - AWS Region (e.g., "us-east-1")
 * @param {string} params.sector - Sector (e.g., "AMESA")
 * @returns {Promise<Object|null>} Generated resource name response or null
 */
export const fetchResourceName = async ({ appShortName, environment, resourceType, accountId, region, sector }) => {
    // Validate required parameters
    if (!appShortName || !environment || !resourceType || !accountId || !region || !sector) {
        return null;
    }

    try {
        const payload = {
            appShortName,
            environment,
            resourceType,
            accountId,
            region,
            sector,
        };

        const response = await axios.post(endPoints.aws.generateResourceName, payload);
        return response?.data || null;
    } catch (error) {
        return null;
    }
};

/**
 * Resource type constants for common AWS resources
 */
export const RESOURCE_TYPES = {
    AWS_ALB: 'awsAlb',
    AWS_NLB: 'awsNlb',
    AWS_LB_TG: 'awslbtg',
    AWS_ALB_TG: 'awsalbtg',
    AWS_NLB_TG: 'awsnlbtg',
    AWS_ALB_RULE: 'awsAlbRule',
    AWS_EXT_NLB: 'awsExtNlb',
    AWS_EXT_NLB_TG: 'awsExtNlbTg',
};

export default {
    fetchResourceName,
    RESOURCE_TYPES,
};
